import { PageConfig, ParcelPopinMode } from "$types";

// Given formula :  [[(longueur en cm/100)*(Largeur en cm/100)/2,4]*qté]
export const calculateLoadingMeters = (
  length: number,
  width: number,
  quantity: number
): number =>
  Number(((length * width * quantity) / (2.4 * 100 * 100)).toFixed(2));

export const pageConfig: PageConfig = {
  [ParcelPopinMode.READ]: {
    title: "Consulter un colisage",
    displayDeleteButton: false,
    displaySubmitButton: false,
    cancelButtonText: "Retour",
  },
  [ParcelPopinMode.EDIT]: {
    title: "Editer un colisage",
    displayDeleteButton: true,
    displaySubmitButton: true,
    cancelButtonText: "Annuler",
  },
  [ParcelPopinMode.CREATE]: {
    title: "Ajouter un colisage",
    displayDeleteButton: false,
    displaySubmitButton: true,
    cancelButtonText: "Annuler",
  },
};

export default {
  calculateLoadingMeters,
};
